import Api from '@/api/index'

const state = {
  all: [],
}

const getters = {}

const actions = {
  async getAll({ commit }, params) {
    const dists = await Api.Distributor.getAll(params)
    if (dists !== null) {
      commit('setDists', dists)
      return dists
    }
    return []
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const dist = await Api.Distributor.getById(params)
    if (dist !== null) {
      return dist
    }
    return null
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    dist
  ) {
    const result = await Api.Distributor.save(dist)
    return result
  },

  async delete(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Distributor.delete(params)
    return result
  },
}

const mutations = {
  setDists(state, dists) {
    state.all = dists.items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
